<script>
  import { onMount, tick } from 'svelte';
  import { scale, fade } from 'svelte/transition';
  import theme from '../theme.js';
  import config from '../config.js';

  export let peer;

  // $: console.log('Person: peer:', peer);

  let personEl;
  let videoEl;
  let snapshotEl;

  const person = {
    x: peer.x,
    y: peer.y,
    diameter: 100,
  };

  // Watch x / y changes
  $: if (peer.x || peer.y) {
    updatePosition(peer.x, peer.y);
  }

  const connectThreshold = 20;
  function updatePosition(x, y) {
    if (!personEl) return;
    personEl.style.left = x + '%';
    personEl.style.top = y + '%';
    if (videoEl && x.proximity) {
      // set volume based on distance... peers near you should be louder
      let volume = (connectThreshold - peer.proximity) / connectThreshold;
      // proximity != 0 even if circles are very close
      // it's equals to zero only when they are directly on top of each other
      volume = volume + 0.3;
      volume = volume > 1 ? 1 : volume;
      videoEl.volume = volume;
    }
  }

  onMount(() => {
    personEl.style.top = peer.y + '%';
    personEl.style.left = peer.x + '%';
  });

  // When the video element is mounted AND the stream is populated, attach stream
  $: if (videoEl && !videoEl.srcObject && peer.stream) {
    console.log('attaching stream');
    if (peer.stream) videoEl.srcObject = peer.stream;
    else delete videoEl.srcObject;
  }
</script>

<style type="text/postcss">
  .person {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 5%;
    width: 5%;
    margin-left: -2.5%;
    margin-top: -2.5%;
    border-radius: 9999px;
    border: 4px solid #444;
    overflow: hidden;
    transform: translateZ(0);
    /* mask-image: radial-gradient(white, black); */
    mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
    transition: all 300ms;
    z-index: 5;
  }
  .video,
  .snapshot {
    max-width: unset;
    height: 150%;
    width: auto;
    position: absolute;
    left: -25%;
    top: -25%;
    border-radius: 9999px;
    border: 4px solid transparent;
    background: #333;
  }
  .video {
    z-index: 1;
  }
  .snapshot {
    z-index: 2;
    width: 120%;
    height: auto;
    left: -10%;
    top: -10%;
    filter: grayscale(100%);
  }
</style>

<div
  bind:this="{personEl}"
  class="person"
  style="border-color: {peer.clusterId ? theme.circle.borderColorActive : theme.circle.borderColor}"
  in:scale
  out:fade="{{ duration: 800 }}">
  <!-- If there's a snapshot, show it over the video (higher z-index) -->
  {#if peer.snapshot && !peer.clusterId}
    <img
      bind:this="{snapshotEl}"
      class="snapshot"
      alt="snapshot"
      src="{peer.snapshot}"
      transition:fade="{{ duration: 50 }}" />
  {/if}
  <!-- Show stream if we have one. -->
  {#if peer.stream && peer.clusterId}
    <video
      bind:this="{videoEl}"
      class="video"
      autoplay
      playsinline
      class:opacity-25="{config.debug.on}"></video>
  {:else}
    <img
      bind:this="{snapshotEl}"
      class="snapshot"
      alt="snapshot"
      src="{peer.snapshot}"
      transition:fade="{{ duration: 50 }}" />
  {/if}
  {#if config.debug.on && peer.id}
    <div class="flex flex-col items-center justify-center h-full w-full absolute inset-0 z-50">
      <h2>{peer.id.slice(-3)}</h2>
      <h2>{(peer.clusterId || '---').slice(-3)}</h2>
    </div>
  {/if}
</div>
